'use client';

import type { ThemeProviderProps } from '@emotion/react';
import { MuiProvider } from '@lfg/ui/providers/MuiProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import React, { PropsWithChildren } from 'react';

import { CustomFont } from '@/components/CustomFonts';
import type { FontConfig } from '@/global/styles/fonts';

export interface NextMuiProviderProps extends ThemeProviderProps {
  config: FontConfig[];
}

export const NextMuiProvider: React.FC<PropsWithChildren<NextMuiProviderProps>> = ({ children, config, theme }) => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiProvider theme={theme}>
        <CustomFont fonts={config} />
        {children}
      </MuiProvider>
    </StyledEngineProvider>
  );
};
